/**
 * Observable
 */
export class Observable {
    constructor() {
        this.observers = [];
        this.notifyEnabled = true;
    }
    /**
     * Adds observer
     * @param observer observer
     */
    addObserver(observer) {
        this.observers.push(observer);
    }
    /**
     * Removes observer
     * @param observer observer
     */
    removeObserver(observer) {
        for (let i = 0, size = this.observers.length; i < size; i++) {
            if (this.observers[i] === observer) {
                this.observers.splice(i, 1);
                return;
            }
        }
    }
    /**
     * Suspends notify
     */
    suspendNotify() {
        this.notifyEnabled = false;
    }
    /**
     * Resumes notify
     */
    resumeNotify() {
        this.notifyEnabled = true;
    }
    /**
     * Notifies to observers
     * @param event event (optional)
     */
    notifyObservers(event) {
        if (this.notifyEnabled) {
            console.debug('Observer.notifyObserver - observers.length', this.observers.length);
            for (let i = this.observers.length - 1; i >= 0; i--) {
                const observer = this.observers[i];
                if (observer.isAvailable()) {
                    observer.update(this, event);
                }
                else {
                    this.observers.splice(i, 1);
                }
            }
        }
    }
}
//# sourceMappingURL=Observable.js.map